import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    _accountCredits: any = {
        purchasedCredits: 0,
        consumedCredits: 0,
        Expiring: 0,
        Expired: 0
    };


    getUserServices(userId: any, page: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getUserServices?page=' + page + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    getAccountCredits(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        this._accountCredits = this.http.get(this.common.apiServiceURL + 'Services/getAccountCredits?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
        return this._accountCredits;
    }

    getAccountPOs(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getAccountPOs?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    getSDRById(sfId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getSDRById?sfId=' + sfId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getSDRSubTasks(SDRId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getSDRSubtasks?SDRId=' + SDRId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getSDRAttachments(SDRId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getSDRAttachments?Id=' + SDRId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    getSDRActivityHistory(SDRId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Services/getSDRActivityHistory?SDRId=' + SDRId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    addAttachment(attachments: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Services/sendSDRAttachments', attachments, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    sendFinalApproval(sdrFApproval: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Services/sendFinalApproval', sdrFApproval, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    sendInitialApproval(sdrApproval: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Services/sendInitialApproval', sdrApproval, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    addSDRActivityHistory(activityHistory: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Services/addSDRActivityHistory', activityHistory, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }

    submitSDR(serviceObject: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Services/addSDR?ownerId=' + userId, serviceObject, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }
}